
import styles from './index.module.scss'
import Utils from '@utils/utils'
import { IMAGE_TYPE, DISPLAY_TYPE } from '@utils/CONST'
import React, { useRef, useState, useMemo, useContext, useEffect } from "react"
import { Checkbox, message } from 'antd';
import TopBtnGroups from './TopBtnGroups'
import BottomBtnGroups from './BottomBtnGroups'
import Iconfont from '@utils/Iconfont';
import API, { commonApiInvoker } from '@api/api.js';
import ShareModal from './shareModal';
import { AppContext } from '@utils/AppContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import PSAIModal from '@PSAIComponents/PSAIModal'

const PictureResultItem = (props) => {
    const { item, imageType, isSelected, selectedList, displayType, rawTasks } = props
    const [showTopBtns, setShowTopBtns] = useState(false)
    const { HDCurrentList, setHDCurrentList } = useContext(AppContext)
    const topBtnRef = useRef()

    const haveHD = useMemo(() => { // 已经高清
        return item?.results?.[0]?.hdImage
    }, [item])

    const disabledHD = useMemo(() => { //高清中
        return item?.results?.[0]?.hdStatus == 'started' ||
            item?.results?.[0]?.hdStatus == 'pending' ||
            item?.results?.[0]?.hdStatus == 'processing'
    }, [item])

    const [dots, setDots] = useState(0);
    useEffect(() => {
        let interval;
        if (item.status == 'started' || item.status == 'pending') {
            interval = setInterval(() => {
                setDots(prevDots => (prevDots + 1) % 4);
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [item.status]);

    const waitTime = (
        <div className={styles.wait_time}>
            <div className={styles.wait_time_}>
                <p>排队中{item.status == 'started' || item.status == 'pending' ? '.'.repeat(dots) : ''}</p>
                {item.status == 'pending' && <p>{item.waitingTime}</p>}
            </div>
        </div>
    )

    const createTime = (
        <div className={styles.create_time}>
            <video
                src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/picProcessingBg.webm"
                autoPlay loop></video>
            <div className={styles.wait_time_}>
                <p>正在生成 {item.progress}</p>
            </div>
        </div>
    )
    const videoRef = useRef()
    const handelVideoPlay = async (play) => {
        try {
            if (play) await videoRef.current.play()
            else await videoRef.current.pause()
        } catch (err) {
            console.error(err)
        }
    }

    // 收藏
    const isLoading = useRef()
    const toBookmark = (e) => {
        e.stopPropagation()
        if (isLoading.current) return
        isLoading.current = true
        API.bookmarkTask({
            taskId: item?.taskId
        }).then(() => {
            props.fetchProjectDetail()
        }).finally(() => {
            isLoading.current = false
        })
    }

    // 分享
    const [shareOpen, setShareOpen] = useState()
    const [shareImg, setShareImg] = useState()
    const mainImage = useMemo(() => { //分享图
        return item?.results?.[0]?.hdImage || item?.results?.[0]?.image
    }, [item])

    const toShare = (e) => {
        e.stopPropagation()
        setShareImg(mainImage)
        setShareOpen(true)
    }

    // 高清下载
    const doHDv2 = async () => {
        const res = await API.doHDv2({ taskId: item?.taskId, imageType: imageType })
        if (res?.code != 0) throw new Error(res?.message)
        props.fetchProjectDetail()
        setHDCurrentList([...HDCurrentList, item?.taskId])
    }

    const successTime = (
        <div className={styles.success_time}>
            {
                (IMAGE_TYPE.MODEL_VIDEO == imageType || IMAGE_TYPE.IMAGE_TO_VIDEO == imageType) ? <div
                    className={styles.videoBox}
                    onMouseEnter={() => handelVideoPlay(true)}
                    onMouseLeave={() => handelVideoPlay(false)}
                >
                    <video
                        ref={videoRef}
                        src={item?.results?.[0]?.image}
                        muted
                        loop
                        disablePictureInPicture
                    />
                    <i className={styles.VideoIcon}></i>
                </div> :
                    <LazyLoadImage
                        alt="example"
                        effect="blur"
                        src={item?.results?.[0]?.image}
                        placeholderSrc={Utils.getImgThumbnail(item?.results?.[0]?.image)}
                    />
            }
        </div>
    )

    const IsEiEdit = useMemo(() => {
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])


    const deleteClick = (e) => {
        e.stopPropagation()
        PSAIModal.confirm({
            centered: true,
            // title: props.imageType == 'tryonVideo' ? "删除视频" : "删除图片",
            // content: `请确认是否删除此${props.imageType == 'tryonVideo' ? "视频" : "结果图"}`,
            title: rawTasks?.length == 1 ? "删除该结果及项目" : "删除该结果",
            content: rawTasks?.length == 1 ? "请确认是否删除该结果及项目？" : "请确认是否删除该结果？",
            icon: null,
            onOk: hadnleDeleteTask
        })
    }
    const hadnleDeleteTask = () => {
        return API.deleteTaskImage({
            taskId: item?.taskId,
            imageId: item?.results?.[0]?.id
        }).then((res) => {
            if (res?.code === 0) {
                if (rawTasks?.length == 1 && displayType == DISPLAY_TYPE.GENERATE) {
                    props.setProjectId('')
                }
                props.fetchProjectDetail()
                message.success('删除成功');
            } else {
                message.error('删除失败');
            }
        })
    };

    return (
        <>
            {
                item.status == 'failed' ? <div className={styles.PictureResultItemFailed}>
                    <Iconfont type="icon-DeleteOutlined" onClick={(e) => deleteClick(e, item)} className={styles.Icon} />
                    <p>生成失败</p>
                    <p>虹豆已退回</p>
                </div> :
                    <div
                        className={styles.PictureResultItem}
                        onMouseEnter={() => setShowTopBtns(true)}
                        onMouseLeave={() => setShowTopBtns(false)}
                        onClick={() => props.handleCLick()}>
                        {
                            item.status == 'started' || item.status == 'pending' ?
                                waitTime : item.status == 'processing' ?
                                    createTime : successTime
                        }
                        {
                            (item.bookmark && !item.orgData) && <span
                                className={styles.IconBg}
                                onClick={(e) => toBookmark(e)}>
                                <Iconfont type="icon-StarFilled" className={styles.Icon} />
                            </span>
                        }
                        {
                            isSelected &&
                            <div
                                className={styles.SelectMask}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    props.selectCurrentItem(item?.taskId)
                                }}>
                                <Checkbox
                                    className={styles.ItemSelect}
                                    checked={selectedList.includes(item?.taskId)}
                                ></Checkbox >
                            </div>
                        }
                        {
                            haveHD &&
                            <span className={styles.HDRibbon}></span>
                        }
                        {
                            disabledHD && <span className={styles.HDPending}>高清生成中</span>
                        }
                        {
                            item.status == 'succeeded' && <TopBtnGroups
                                deleteClick={deleteClick}
                                displayType={displayType}
                                imageType={imageType}
                                showTopBtns={showTopBtns}
                                item={item}
                                taskId={item?.taskId}
                                setShowTopBtns={setShowTopBtns}
                                toBookmark={toBookmark}
                                toShare={toShare}
                                doHDv2={doHDv2}
                                handleReclipa={props.handleReclipa}
                                fetchProjectDetail={props.fetchProjectDetail}
                                changeModelOrSenceClick={props.changeModelOrSenceClick}
                            />
                        }
                        {
                            (item.status == 'succeeded' && !IsEiEdit && !item.orgData) &&
                            <BottomBtnGroups
                                imageType={imageType}
                                displayType={displayType}
                                item={item}
                                showTopBtns={showTopBtns}
                                setShowTopBtns={setShowTopBtns} />
                        }
                    </div>

            }

            <ShareModal
                open={shareOpen}
                shareImg={shareImg}
                closeFunc={() => setShareOpen(false)} />
        </>

    )
}

export default PictureResultItem